import React from 'react'
import cx from 'classnames'

import * as s from './AspectContainer.scss'


type AspectContainerProps = {
  children: React.ReactElement<{ className?: string }>
  className?: string // comes from <Box noWrapper>
  aspect?: number // w / h, e.g. 1.33
  fit?: 'cover' | 'contain'
  dataTestId?: string
}

// It helps to create placeholders for images
const AspectContainer: React.FC<AspectContainerProps> = (props) => {
  const { children, className, aspect = 1, fit = 'cover', dataTestId, ...rest } = props

  const placeholderStyle = {
    paddingTop: `${Math.round(100 / aspect)}%`,
  }

  const childClassName = cx(s.child, children.props.className, {
    [s.fitCover]: fit === 'cover',
    [s.fitContain]: fit === 'contain',
  })

  return (
    <div className={cx(className, 'relative')} data-testid={dataTestId} {...rest}>
      <div style={placeholderStyle} />
      {
        React.cloneElement(
          children,
          {
            className: childClassName,
          }
        )
      }
    </div>
  )
}


export default React.memo(AspectContainer)
